import { ScenarioObjectBase } from './base/scenario-object-base';
import { ScenarioDrillGroupFilterCriteria } from './scenario-drill-group-filter-criteria';
import { IScenarioObject } from '../interfaces/iscenario-object';

export class ScenarioObject extends ScenarioObjectBase {
  PreliminaryFilterCriteria: ScenarioDrillGroupFilterCriteria;

  constructor(item?: IScenarioObject) {
    super(item);

    if (item && item.PreliminaryFilterCriterias) {
      ScenarioObject.convert(item.PreliminaryFilterCriterias, this.PreliminaryFilterCriteria);
    }
  }

  private static convert(raw: string | object, dest: any): void {
    if (raw && typeof raw === 'string') {
      let copy;
      try {
        copy = JSON.parse(raw);
      } catch (e) {
        console.error('error converting ScenarioObject');
      }
      Object.assign(dest, copy);
    } else if (raw) {
      Object.assign(dest, raw);
    }
  }

  static map(raw: IScenarioObject[]): ScenarioObject[] {
    if (raw && raw.length) {
      return raw.map(this.mapone);
    } else {
      return [];
    }
  }

  static mapone(raw: IScenarioObject): ScenarioObject {
    let result = new ScenarioObject();
    Object.assign(result, raw);
    result.PreliminaryFilterCriteria = new ScenarioDrillGroupFilterCriteria();
    ScenarioObject.convert(raw.PreliminaryFilterCriterias, result.PreliminaryFilterCriteria);
    result.PreliminaryFilterCriteria.ScenarioStartDate = new Date(result.PreliminaryFilterCriteria.ScenarioStartDate);
    result.PreliminaryFilterCriteria.ScenarioEndDate = new Date(result.PreliminaryFilterCriteria.ScenarioEndDate);
    return result;
  }
}